import { render, staticRenderFns } from "./RequAddMain.vue?vue&type=template&id=597d6c00&scoped=true&"
import script from "./RequAddMain.vue?vue&type=script&lang=js&"
export * from "./RequAddMain.vue?vue&type=script&lang=js&"
import style0 from "./RequAddMain.vue?vue&type=style&index=0&id=597d6c00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597d6c00",
  null
  
)

export default component.exports